import { render, staticRenderFns } from "./NoResultsMessage.vue?vue&type=template&id=5e8a11bd"
import script from "./NoResultsMessage.vue?vue&type=script&lang=js"
export * from "./NoResultsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports